import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { PageLayoutComponent } from '../../components/shared/page-layout/page-layout.component';

interface JobOffer {
  title: string;
  description: string;
  link: string;
}

@Component({
  selector: 'app-recrutement',
  standalone: true,
  imports: [CommonModule, RouterModule, PageLayoutComponent],
  templateUrl: './recrutement.component.html',
  styleUrl: './recrutement.component.scss'
})
export class RecrutementComponent {
  // Page layout configuration
  title = 'Rejoignez Notre Équipe';
  subtitle = 'Découvrez nos opportunités de carrière et faites partie d\'une équipe dynamique et innovante dans le courtage en assurance.';
  heroImage = 'assets/static_pages_images/recrutement.jpg';
  breadcrumbs = [{ label: 'Recrutement', link: undefined }];
  prevPage = { title: 'Notre Équipe', link: '/notre-equipe' };
  nextPage = { title: 'Contact', link: '/contact' };

  // Job offers data
  jobOffers: JobOffer[] = [
    {
      title: 'Marketing',
      description: "Exécuter la stratégie digitale de bout en bout sur une multitude de canaux afin de maximiser la visibilité et la notoriété du cabinet.",
      link: '/offres/marketing'
    }
  ];
}
